import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './style.module.css';
import * as routes from '../../constants/Routes';

interface IFloatingTutorials {
  title?: string;
  subtitle?: string;
  links?: Array<{ title: string; link: string }>;
}

export function FloatingTutorials({
  title,
  subtitle,
  links,
}: IFloatingTutorials) {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [linkPlay, setLinkPlay] = useState('');

  // Se não tiver props, usa o comportamento de redirecionamento (usado no Navbar)
  const hasProps = title && subtitle && links;

  if (!hasProps) {
    return (
      <div className={styles.boxPosition}>
        <div
          className={`${styles.button} shadow`}
          onClick={() => {
            navigate(routes.INFOS);
          }}
        >
          <i
            className="material-icons text-secondary me-1"
            style={{ fontSize: '16px' }}
          >
            contact_support
          </i>
          Ajuda?
        </div>
      </div>
    );
  }

  // Se tiver props, usa o comportamento de modal (usado em Login/Register)
  return (
    <>
      <div
        className="modal fade"
        id="videomodal"
        aria-labelledby="videoModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog bg-transparent modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="videoModalLabel">
                Video ajuda
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setLinkPlay('');
                }}
              ></button>
            </div>
            <div className="modal-body bg-body d-flex justify-content-center">
              <iframe
                src={linkPlay}
                title="YouTube video player"
                style={{ height: 400, width: 184.3 }}
                className="rounded-4"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.boxPosition}>
        <div
          className={`${styles.button} shadow`}
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          <i
            className="material-icons text-secondary me-1"
            style={{ fontSize: '16px' }}
          >
            contact_support
          </i>
          Ajuda?
        </div>
        {isOpen && (
          <div className={`${styles.box} shadow`}>
            <div className="py-3">
              <div className="d-flex align-items-center justify-content-between">
                <p className="fw-semibold">{title}</p>
                <button
                  className="btn"
                  onClick={() => {
                    setIsOpen(!isOpen);
                  }}
                >
                  <i className="material-icons text-secondary">close</i>
                </button>
              </div>
              <p>{subtitle}</p>
              <hr />
              {links &&
                links.map((link, index) => (
                  <div className="d-grid mb-3" key={index}>
                    <button
                      className="btn bg-primary text-white d-flex align-items-center justify-content-center"
                      data-bs-toggle="modal"
                      data-bs-target="#videomodal"
                      onClick={() => {
                        setLinkPlay(link.link);
                      }}
                    >
                      {link.title}
                      <i className="material-icons text-secondary ms-2 text-white">
                        play_arrow
                      </i>
                    </button>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
}
